import { Theme } from '@mui/material';
import styled from '@mui/system/styled';

export const PriceTagContainer = styled('div')(
  ({ theme }: { theme?: Theme }) => ({
    marginTop: '-2px',
    marginLeft: '1px',
    '@media (max-width: 320px) ': {
      marginLeft: '-4px'
    },
    '@media (min-width: 481px) ': {
      marginTop: '2px'
    },
    [theme.breakpoints.up('sm')]: {
      marginTop: '2.5px',
      marginLeft: 0
    }
  })
);

export const OfferFlag = styled('div')(({ theme }: { theme?: Theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  fontSize: '12px',
  color: '#fff',
  lineHeight: 1,
  padding: '6px 14px 5px 8px',
  borderTopLeftRadius: '3px',
  borderBottomLeftRadius: '3px',
  position: 'relative',
  marginBottom: '2px',
  maxWidth: '170px',
  '&::after': {
    content: '""',
    position: 'absolute',
    top: '3px',
    right: '-8px',
    width: '18px',
    height: '17px',
    backgroundColor: '#fff',
    MozTransform: 'rotate(45deg)',
    OTransform: 'rotate(45deg)',
    msTransform: 'rotate(45deg)',
    transform: 'rotate(45deg)',
    WebkitTransform: 'rotate(45deg)'
  },
  '@media (max-width: 320px) ': {
    fontSize: '11px',
    padding: '4px 4px 4px 3px',
    '&::after': {
      top: '1px',
      width: '16px'
    }
  },
  '@media (min-width: 481px) ': {
    maxWidth: '173px'
  },
  [theme.breakpoints.up('sm')]: {
    fontSize: '14px',
    maxWidth: '190px',
    paddingLeft: '7px',
    '&::after': {
      top: '5px',
      right: '-10px',
      width: '20px'
    }
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '12px',
    padding: '5px 12px 4px 4px',
    '&::after': {
      top: '3px'
    }
  },
  [theme.breakpoints.up('lg')]: {
    padding: '6px 14px 5px 8px'
  }
}));

export const Price = styled('div')(
  ({ theme, strikeThrough }: { theme?: Theme; strikeThrough?: boolean }) => ({
    position: 'relative',
    display: 'inline-block',
    '& .price': {
      fontSize: '18px',
      fontWeight: 500
    },
    '& .per-min': {
      fontSize: '14px',
      fontWeight: '400'
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      top: '12px',
      left: 0,
      right: 0,
      borderTop: strikeThrough
        ? `2px solid ${theme?.palette.secondary.main}`
        : ''
    },
    '@media (max-width: 320px) ': {
      '& .price': {
        fontSize: '16px'
      },
      '& .per-min': {
        fontSize: '12px'
      },
      '&::after': {
        top: '13px'
      }
    },
    [theme.breakpoints.up('sm')]: {
      marginLeft: '-1px',
      '& .price': {
        fontSize: '20px'
      },
      '&::after': {
        top: '14px'
      }
    },
    [theme.breakpoints.up('md')]: {
      marginLeft: 0,
      '& .price': {
        fontSize: '22px'
      },
      '& .per-min': {
        fontSize: '16px'
      },
      '&::after': {
        top: '15px'
      }
    }
  })
);
